// extracted by mini-css-extract-plugin
export default {"avatar":"ContactsList_avatar__E4nUq","tag":"ContactsList_tag__-41Uf"};